import { AMPLITUDE_API_KEY } from '@/constant';
import * as amplitudeAnalyticsBrowser from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import type React from 'react';
import { createContext, useContext, useMemo } from 'react';

type AmplitudeProviderProps = {
  children: React.ReactNode;
};

const initAmplitude = () => {
  const options = {
    defaultTracking: true,
    minIdLength: 1,
  };

  if (AMPLITUDE_API_KEY) {
    amplitudeAnalyticsBrowser.init(AMPLITUDE_API_KEY, options);
    amplitudeAnalyticsBrowser.add(engagementPlugin()); // for guide and surveys
  } else {
    // ApiKeyがない場合にエラーが発生するため、DEVELOPMENT_MODEという値を設定して、イベントのLoggingを無効化
    amplitudeAnalyticsBrowser.init('DEVELOPMENT_MODE', options);
    amplitudeAnalyticsBrowser.setOptOut(true);
  }
  return amplitudeAnalyticsBrowser;
};

const amplitude = initAmplitude();

type Context = {
  amplitude: typeof amplitudeAnalyticsBrowser;
};

const AmplitudeContext = createContext<Context>({
  amplitude,
});

export const useAmplitudeContext = () => useContext(AmplitudeContext);

export const AmplitudeProvider: React.FC<AmplitudeProviderProps> = ({
  children,
}) => {
  const provider = useMemo(() => {
    return { amplitude };
  }, []);

  return (
    <AmplitudeContext.Provider value={provider}>
      {children}
    </AmplitudeContext.Provider>
  );
};
